import Button from "@/common/components/Button";
import Modal from "@/common/components/Modal";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import { FormTransformers } from "@/common/utils/formTransformers";
import { useQueryClient } from "@tanstack/react-query";
import { Trash2Icon } from "lucide-react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useDeleteDiagnosticObjectiveActivity } from "../../../../../../hooks/diagnosticObjectiveActivities/useDeleteDiagnosticObjectiveActivity";
import { DiagnosticActivityData } from "@/features/maintenance/features/workflows/types/forwardings/directiveEntries/diagnosticEntry/diagnosticEntry.type";

interface DeleteDiagnosticObjectiveActivityProps {
  diagnosticActivity: DiagnosticActivityData;
}

const DeleteDiagnosticObjectiveActivity = ({
  diagnosticActivity
}: DeleteDiagnosticObjectiveActivityProps) => {
  const { forwardingId } = useParams();

  const queryClient = useQueryClient();

  const [isOpen, setIsOpen] = useState(false);

  const [messages, setMessages] = useState<string[] | boolean>(false);

  const {
    mutate: deleteActivity,
    isPending: deleteActivityIsPending,
  } = useDeleteDiagnosticObjectiveActivity({
    diagnosticObjectiveActivityId: diagnosticActivity.id,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['maintenanceForwarding', forwardingId] });

        setIsOpen(false);
      },
      onError: (error) => {
        FormTransformers.errorsTransformer({
          setMessages,
        })(error);
      }
    }
  });

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        Trigger={(
          <Button
            variant="link-white"
            operationKlassToCheckPermission="Establishment::Maintenance::DiagnosticObjectiveActivities::Destroy"
          >
            <Trash2Icon strokeWidth={1} className="text-danger" />
          </Button>
        )}
        title="Você tem certeza?"
        subtitle="Esse serviço será removido do seu orçamento"
        useCancellableFooter
        showClose={false}
        titleClass="text-2xl"
        subtitleClassName="text-sm mt-2"
        className="rounded-lg overflow-hidden"
        cancelButtonClassName="bg-white-100"
        onConfirm={deleteActivity}
        confirmButtonIsLoading={deleteActivityIsPending}
      />

      <ModalMessageSimple
        messages={messages}
        setMessages={setMessages}
        isError
      />
    </>
  );
}

export default DeleteDiagnosticObjectiveActivity;
